import * as React from "react";
import styled, { css } from "styled-components";
import { Dropdown, MenuItem } from "components/bootstrap";
const Caret = styled.span(
  ({ theme }) => css`
    display: block;
    content: ' ';
    float: right;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-left-color: ${theme.colors.gray[80]};
    margin-top: 5px;
    margin-right: -10px;
  `
);
const StyledSubmenu = styled(Dropdown)(
  ({ $left, theme }) => css`
    position: relative;
    display: flex;
    gap: 5px;

    > a {
      color: ${theme.colors.text.primary};
    }

    > .dropdown-menu {
      top: 0;
      left: ${$left ? "auto" : "100%"};
      right: ${$left ? "98%" : "auto"};
      margin-top: -6px;
      margin-left: ${$left ? "10px" : "-1px"};
      border-radius: ${$left ? "6px 0 6px 6px" : "0 6px 6px 6px"};
      background-color: ${theme.colors.global.contentBackground};
    }

    &:hover > .dropdown-menu {
      display: block;
    }
  `
);
const DropdownSubmenu = ({ children, left = false, title = void 0 }) => /* @__PURE__ */ React.createElement(MenuItem, null, /* @__PURE__ */ React.createElement(StyledSubmenu, { $left: left, as: "div" }, title, " ", /* @__PURE__ */ React.createElement(Caret, null), /* @__PURE__ */ React.createElement(Dropdown.Menu, null, children)));
export default DropdownSubmenu;
